// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .RegisterInCoursePreferences
{
    display: flex;
    width: 25%;
    height: auto;
    background-color: #34979c;
    border-radius: 2vh;
    margin-left: 10%;
    padding: 2%;
    margin-top: 3vh;
    float: left;
} */
/* .RegisterInCoursePreferencesDays,.RegisterInCoursePreferencesTimes
{
    /* display: flex;
    flex-direction: column; */
    
/*} 
.RegisterInCoursePreferencesTimes
{

}

.days
{
    float:left;
    margin-right:9vh;
    color:white;
}
.Times{
    color:white;
}
.DiscountCode
{
    display: flex;
    width: auto;
    height: auto;
    align-items: center;
    justify-content: center;
}
.DiscountInputCode
{
    padding: 1%;
    border: 1px solid rgb(219, 213, 213);
    border-radius: 1vh;
    margin: 0 10% 0 0;
}
.DiscountInputCode:hover
{
    border: 1px solid rgb(7, 39, 179);
}
.RegisterCourseButton
{
    padding: 1% 2% 1% 2%;
    
}
.PaymentMessage
{
    margin: 3% 0% 0 20%;
}*/
.register-course-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  
  .course-registration-info {
    max-width: 60%;
    text-align: center;
    margin-bottom: 20px;
    color: rgb(52, 151, 156);
    font-weight: bold; /* Make text bold */
  }
  
  .course-registration-info p {
    font-size: 1.1em;
    color: rgb(52, 151, 156);
    font-weight: bold; 
    text-align: center;
  }
  
  .course-registration-info ul {
    list-style-type: none;
    padding: 0;
  }
  
  .course-registration-info li {
    font-size: 1.1em;
    color: rgb(52, 151, 156);
    font-weight: bold; 
    margin: 5px 0;
    text-align: center;
  }
  
  .course-table {
    width: 80%;
    overflow-x: auto;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
  
  .course-table table {
    width: 100%;
    border-collapse: collapse;
    background-color: #e0f7fa;
  }
  
  .course-table th,
  .course-table td {
    padding: 12px 16px;
    text-align: left;
    border: 1px solid #ddd;
  }
  
  .course-table th {
    background-color: #008080;
    color: #fff;
    font-weight: bold;
  }
  
  .course-table td {
    color: rgb(52, 151, 156);
    font-weight: bold; 
  }
  
  .course-table tr:nth-child(even) {
    background-color: #f2f2f2;
  }
  
  .course-table td:last-child {
    width: 40%;
  }
  `, "",{"version":3,"sources":["webpack://./src/MyComponents/Actions/RegisterInCourse.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;GAWG;AACH;;;6BAG6B;;AAE7B;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0CE;AACF;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB,EAAE,mBAAmB;EACxC;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,0CAA0C;IAC1C,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;;IAEE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,UAAU;EACZ","sourcesContent":["/* .RegisterInCoursePreferences\n{\n    display: flex;\n    width: 25%;\n    height: auto;\n    background-color: #34979c;\n    border-radius: 2vh;\n    margin-left: 10%;\n    padding: 2%;\n    margin-top: 3vh;\n    float: left;\n} */\n/* .RegisterInCoursePreferencesDays,.RegisterInCoursePreferencesTimes\n{\n    /* display: flex;\n    flex-direction: column; */\n    \n/*} \n.RegisterInCoursePreferencesTimes\n{\n\n}\n\n.days\n{\n    float:left;\n    margin-right:9vh;\n    color:white;\n}\n.Times{\n    color:white;\n}\n.DiscountCode\n{\n    display: flex;\n    width: auto;\n    height: auto;\n    align-items: center;\n    justify-content: center;\n}\n.DiscountInputCode\n{\n    padding: 1%;\n    border: 1px solid rgb(219, 213, 213);\n    border-radius: 1vh;\n    margin: 0 10% 0 0;\n}\n.DiscountInputCode:hover\n{\n    border: 1px solid rgb(7, 39, 179);\n}\n.RegisterCourseButton\n{\n    padding: 1% 2% 1% 2%;\n    \n}\n.PaymentMessage\n{\n    margin: 3% 0% 0 20%;\n}*/\n.register-course-page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n    font-family: Arial, sans-serif;\n  }\n  \n  .course-registration-info {\n    max-width: 60%;\n    text-align: center;\n    margin-bottom: 20px;\n    color: rgb(52, 151, 156);\n    font-weight: bold; /* Make text bold */\n  }\n  \n  .course-registration-info p {\n    font-size: 1.1em;\n    color: rgb(52, 151, 156);\n    font-weight: bold; \n    text-align: center;\n  }\n  \n  .course-registration-info ul {\n    list-style-type: none;\n    padding: 0;\n  }\n  \n  .course-registration-info li {\n    font-size: 1.1em;\n    color: rgb(52, 151, 156);\n    font-weight: bold; \n    margin: 5px 0;\n    text-align: center;\n  }\n  \n  .course-table {\n    width: 80%;\n    overflow-x: auto;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n  }\n  \n  .course-table table {\n    width: 100%;\n    border-collapse: collapse;\n    background-color: #e0f7fa;\n  }\n  \n  .course-table th,\n  .course-table td {\n    padding: 12px 16px;\n    text-align: left;\n    border: 1px solid #ddd;\n  }\n  \n  .course-table th {\n    background-color: #008080;\n    color: #fff;\n    font-weight: bold;\n  }\n  \n  .course-table td {\n    color: rgb(52, 151, 156);\n    font-weight: bold; \n  }\n  \n  .course-table tr:nth-child(even) {\n    background-color: #f2f2f2;\n  }\n  \n  .course-table td:last-child {\n    width: 40%;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
